import axios from 'axios';

//let root = "http://localhost";
let root = window.location.protocol + "//" + window.location.host;
let authHeader = { headers: { 'Authorization': "Bearer " +  sessionStorage.getItem('token') } }
export default {
    async postAsync(path, json) {
      return this.post(path, json)
    },

    post(path, json) {
        let header = JSON.parse(JSON.stringify(authHeader));
        header.headers.timeout = 30000;
        return axios.post(root + '/v2/api/partner' + path, json, header)
		.catch(error => {
            if (error.message.indexOf("Network Error") >= 0) {
    		    throw new Error("Network Error");
            }
            if (error.message.indexOf("timeout") >= 0) {
    		    throw new Error("Timeout Error");
    		    return;
            }
            switch(error.response.status) {
                case 403:
                    window.location.href = root + '/static/partner-login.html';
                    break;
                default:
                    throw new Error("Server Error status=" + error.response.status);
                    break;
            }
		});
    },
    downloadBlob(path, json) {
        let header = JSON.parse(JSON.stringify(authHeader));
        header.responseType = 'blob';
        return axios.post(root + '/v2/api/partner' + path, json, header)
        .catch(error => {
            if (error.message.indexOf("Network Error") >= 0) {
    		    throw new Error("Network Error");
            } else {
		        switch(error.response.status) {
                    case 403:
        				window.location.href = root + '/static/partner-login.html';
                        break;
                    default:
            		    throw new Error("Server Error status=" + error.response.status);
            		    break;
                }
            }
        });
    },
    postNoError(path, json) {
        return axios.post(root + '/v2/api/partner' + path, json, authHeader);
    },

};
